import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Desafios_Cursos } from 'generated/graphql';

const initialState: Desafios_Cursos | any = null;

const currentDesafioCursoStateSlice = createSlice({
	name: 'currentDesafioState',
	initialState,
	reducers: {
		setCurrentDesafioCursoState: (state, action: PayloadAction<Desafios_Cursos | any>) => {
			if (action.payload === null) {
				return initialState;
			}
			return action.payload;
		},
		resetCurrentDesafioCursoState: () => {
			return initialState;
		}
	}
});

export const { setCurrentDesafioCursoState, resetCurrentDesafioCursoState } = currentDesafioCursoStateSlice.actions;

export default currentDesafioCursoStateSlice.reducer;
